import { render, staticRenderFns } from "./tournament.vue?vue&type=template&id=7525332e&scoped=true"
import script from "./tournament.vue?vue&type=script&lang=js"
export * from "./tournament.vue?vue&type=script&lang=js"
import style0 from "./tournament.vue?vue&type=style&index=0&id=7525332e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7525332e",
  null
  
)

export default component.exports